var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _circle, _circle2, _linearGradient, _path23, _path24, _path25, _path26, _circle3, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _g, _g2, _g3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgConnect(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "connect_svg___x30_28cd87a-0b35-461a-bfe3-3b7f66159f45",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 400 200",
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".connect_svg__st0{fill:none;stroke:#535461;stroke-width:.4639;stroke-miterlimit:2.3197}.connect_svg__st1{fill:#6c63ff}.connect_svg__st2{fill:#fc6681}.connect_svg__st3{fill:#ffd037}.connect_svg__st5{fill:#ffd5d8}.connect_svg__st6{opacity:.1;enable-background:new}.connect_svg__st8{fill:#fff}.connect_svg__st9{enable-background:new}.connect_svg__st10,.connect_svg__st9{opacity:.2}.connect_svg__st11{fill:#564fcc}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "connect_svg__path13",
    className: "connect_svg__st0",
    d: "M109.3,123.3c0,0-13.6-26.7-7.6-49.3c2.5-9.5,2-19.5-1.6-28.7c-1.8-4.3-3.9-8.5-6.4-12.4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "connect_svg__path15",
    className: "connect_svg__st1",
    d: "M97.3,18.7c0.6,3.5-3.7,14.7-3.7,14.7s-8.1-8.9-8.8-12.3c-0.6-3.5,1.8-6.8,5.3-7.3 C93.4,13.2,96.6,15.3,97.3,18.7L97.3,18.7z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "connect_svg__path17",
    className: "connect_svg__st1",
    d: "M111.3,35.9c-1.3,3.2-11.1,10.3-11.1,10.3s-2-11.9-0.7-15.1c1.3-3.3,5-4.9,8.3-3.5 C111,28.8,112.6,32.5,111.3,35.9C111.3,35.8,111.3,35.9,111.3,35.9L111.3,35.9z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "connect_svg__path19",
    className: "connect_svg__st1",
    d: "M117,68.7c-2.8,2.1-14.8,3.3-14.8,3.3s4.2-11.3,7-13.4c2.8-2.1,6.8-1.6,8.9,1.2 C120.3,62.6,119.8,66.6,117,68.7z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "connect_svg__path21",
    className: "connect_svg__st1",
    d: "M115.7,94.5c-2.4,2.6-14,5.7-14,5.7s2.3-11.8,4.7-14.4c2.4-2.6,6.4-2.7,9-0.3 C117.9,88,118,92,115.7,94.5L115.7,94.5z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "connect_svg__path23",
    className: "connect_svg__st1",
    d: "M87.1,49.3c2.9,1.9,15,2.3,15,2.3s-5-11-7.9-12.9c-2.9-1.9-6.9-1.1-8.8,1.8 C83.4,43.4,84.2,47.4,87.1,49.3L87.1,49.3L87.1,49.3z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "connect_svg__path25",
    className: "connect_svg__st1",
    d: "M86,79.5c3.4,1,15-2.3,15-2.3s-8-9-11.4-9.9c-3.4-0.9-6.9,1.1-7.8,4.5C80.8,75.1,82.7,78.5,86,79.5 L86,79.5z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "connect_svg__path27",
    className: "connect_svg__st1",
    d: "M88.9,109c3.2,1.5,15.1,0.3,15.1,0.3s-6.4-10.2-9.6-11.7c-3.2-1.5-7-0.2-8.5,3S85.8,107.5,88.9,109 L88.9,109L88.9,109z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "connect_svg__path29",
    className: "connect_svg__st2",
    d: "M97.3,18.7c0.6,3.5-3.7,14.7-3.7,14.7s-8.1-8.9-8.8-12.3c-0.6-3.5,1.8-6.8,5.3-7.3 C93.4,13.2,96.6,15.3,97.3,18.7L97.3,18.7z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "connect_svg__path31",
    className: "connect_svg__st2",
    d: "M111.3,35.9c-1.3,3.2-11.1,10.3-11.1,10.3s-2-11.9-0.7-15.1c1.3-3.3,5-4.9,8.3-3.5 C111,28.8,112.6,32.5,111.3,35.9C111.3,35.8,111.3,35.9,111.3,35.9L111.3,35.9z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "connect_svg__path33",
    className: "connect_svg__st2",
    d: "M117,68.7c-2.8,2.1-14.8,3.3-14.8,3.3s4.2-11.3,7-13.4c2.8-2.1,6.8-1.6,8.9,1.2 C120.3,62.6,119.8,66.6,117,68.7z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "connect_svg__path35",
    className: "connect_svg__st2",
    d: "M115.7,94.5c-2.4,2.6-14,5.7-14,5.7s2.3-11.8,4.7-14.4c2.4-2.6,6.4-2.7,9-0.3 C117.9,88,118,92,115.7,94.5L115.7,94.5z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "connect_svg__path37",
    className: "connect_svg__st2",
    d: "M87.1,49.3c2.9,1.9,15,2.3,15,2.3s-5-11-7.9-12.9c-2.9-1.9-6.9-1.1-8.8,1.8 C83.4,43.4,84.2,47.4,87.1,49.3L87.1,49.3L87.1,49.3z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "connect_svg__path39",
    className: "connect_svg__st2",
    d: "M86,79.5c3.4,1,15-2.3,15-2.3s-8-9-11.4-9.9c-3.4-0.9-6.9,1.1-7.8,4.5C80.8,75.1,82.7,78.5,86,79.5 L86,79.5z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "connect_svg__path41",
    className: "connect_svg__st2",
    d: "M88.9,109c3.2,1.5,15.1,0.3,15.1,0.3s-6.4-10.2-9.6-11.7c-3.2-1.5-7-0.2-8.5,3S85.8,107.5,88.9,109 L88.9,109L88.9,109z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "connect_svg__path43",
    className: "connect_svg__st0",
    d: "M290,73.6c0,0,17.3-27.2,19.4-38.8s6-22.3,6-22.3"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "connect_svg__path45",
    className: "connect_svg__st1",
    d: "M319.3,35.7l-10.9,0.9C308.4,36.7,314.2,46.6,319.3,35.7z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "connect_svg__path47",
    className: "connect_svg__st1",
    d: "M300.3,29.7l8.6,6.9C308.9,36.6,297.8,41.1,300.3,29.7z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "connect_svg__path49",
    className: "connect_svg__st1",
    d: "M320.7,26.2l-9.8,1.3C310.9,27.5,319.6,34.6,320.7,26.2z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "connect_svg__path51",
    className: "connect_svg__st1",
    d: "M304.5,22.8l6.5,4.5C311,27.3,303.1,30.6,304.5,22.8z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "connect_svg__path53",
    className: "connect_svg__st1",
    d: "M313.4,18.6c0,0,8-2.1,9.2-1.7s0.5,5.6-2.8,5.8S313.4,18.6,313.4,18.6z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "connect_svg__path55",
    className: "connect_svg__st1",
    d: "M308,12.5c0,0,5.1,4.9,5.3,6c0.2,1.2-4.2,3.9-6.5,0S308,12.5,308,12.5z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "connect_svg__circle57",
    className: "connect_svg__st3",
    cx: 317.5,
    cy: 13,
    r: 2.3
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "connect_svg__circle59",
    className: "connect_svg__st3",
    cx: 313.3,
    cy: 11.9,
    r: 2.3
  })), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "connect_svg__path61_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 589.429,
    y1: -1006.789,
    x2: 589.429,
    y2: -144.764,
    gradientTransform: "matrix(.232 0 0 -.232 60.82 -33.563)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "gray",
    stopOpacity: 0.1
  }))), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "connect_svg__path61",
    d: "M318,61.4c-0.9-11.2-6-22-14-28.3c-8.5-6.8-19.3-8-29-12.1c-10-4.2-19-11.4-28.9-15.9 c-16.3-7.3-35-6.9-51,1.2c-10.8,5.5-21.8,18.2-33.8,19.2c-8.6,0.7-25.8-7.9-32.5,0.2c-1.2,1.5-1.7,3.6-2.2,5.5 C122.4,47.2,111.9,59.9,100,69c-5,3.9-11.2,9-10.1,15.9c0.6,3.7,3.2,6.4,5.1,9.5c4.1,6.3,5.4,14.9,3.4,22.5c0,0.2-0.1,0.3-0.1,0.5 l-5.1,2.6c-2.7,1.4-5.6,3-6.7,5.8c-1.1,2.9,0.1,6.2,1.7,8.9c1.1,1.9,2.5,3.8,3.5,5.7c0.1,0.7,0.2,1.3,0.3,1.9c0.2,1,0.5,1.9,0.9,2.8 c0.1,3.1-1.1,6.3-2.8,9c-2.1,3.4-4.9,6.3-7.2,9.5c-3.3,4.4-5.7,9.6-6.1,15.1c-0.4,5.5,1.6,11.3,5.9,14.8c3.9,3.2,9.2,4.2,14.2,4.4 c1.3,0.1,2.6,0.1,3.8,0.1c9,0,18-1.7,26.9-3.3l9.6-1.8c4.4-0.8,9-1.8,13.2-3.3c-0.1,0.9-0.3,1.8-0.5,2.6c-0.7,2.5-1,5.1-0.9,7.7l0,0 h47.3c0,0,0,0.1,0,0.1h29.3l-0.1-0.1h0.1c0,0-0.4-1.4-1-4c0.7-0.3,1.3-0.8,1.9-1.3c1.4-0.9,2.5-2.1,3.2-3.6c0,0,1.4-25.2,0-39.6 c15.2-10.1,28.2-24.9,44.2-33.5c8.3-4.5,17.3-7.3,25-13c4.3-3.3,8-7.3,11-11.9C315.8,84,318.9,72.6,318,61.4z",
    fill: "url(#connect_svg__path61_1_)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "connect_svg__path63",
    className: "connect_svg__st1",
    d: "M130.6,27.6c-1.2,1.4-1.7,3.5-2.2,5.4 c-4.1,15.4-14.3,27.8-25.9,36.7c-4.9,3.8-10.9,8.8-9.8,15.5c0.6,3.6,3.1,6.3,5,9.2c4,6.2,5.2,14.5,3.4,21.9 c-2.1,8.4-8.1,16.2-6.3,24.7c1.1,5.2,5,8.9,8.8,12.1c5.8,5,11.8,9.7,18.1,14c4.2,2.9,8.6,5.8,13.4,6.1c4.3,0.3,8.4-1.3,12.5-2.9 c3.5-1.4,7.2-2.9,10-5.7c1.9-1.8,3.4-4.2,5.4-5.7c4.9-3.5,11.1-1.3,16.7,0.2c13.3,3.5,27.4,2.2,39.8-3.6c19.2-9,33.9-28,52.7-38.2 c8.1-4.4,16.9-7.1,24.4-12.7c4.2-3.2,7.8-7.1,10.7-11.6c5.7-8.7,8.7-19.9,7.8-30.8c-0.9-10.9-5.8-21.4-13.6-27.6 c-8.3-6.6-18.8-7.8-28.3-11.8C263.4,19,254.7,11.9,245,7.6c-15.9-7.2-34.2-6.7-49.7,1.1c-10.5,5.3-21.2,17.8-33,18.7 C153.9,28.1,137.2,19.7,130.6,27.6L130.6,27.6z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    id: "connect_svg__path67",
    className: "connect_svg__st5",
    d: "M196.3,89c-7.6,22.1-6.7,29.6-6.7,29.6l1.6,12.5c0,0-32.7,4.6-27.6-10.7c2.9-8.8,2.3-22.9,1.2-33.3 c-0.8-7.8-1.9-13.5-1.9-13.5l37.6,3.9C198.8,81.7,197.4,85.5,196.3,89z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    id: "connect_svg__path69",
    className: "connect_svg__st6",
    d: "M200.5,77.5c-1.6,4.2-3,8-4.2,11.5c-9.6,7-22.8,6.2-31.5-1.9c-0.8-7.8-1.9-13.5-1.9-13.5 L200.5,77.5z"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    id: "connect_svg__circle71",
    className: "connect_svg__st5",
    cx: 181.7,
    cy: 68.4,
    r: 24.8
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    id: "connect_svg__path73",
    className: "connect_svg__st5",
    d: "M198.4,132.4l-14.6-6.3l2.6-19.5c2.1,0.2,4.2,0.7,6.3,1.4c5.6,1.8,13.2,5.9,14.8,15c0,0,0,0,0,0 C210,138,198.4,132.4,198.4,132.4z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    id: "connect_svg__path75",
    d: "M207.4,123.1l-2,2.9l-7.9,0.5v-5.3c0,0-1.9-6.1-1.9-6.6c0-0.5-3.1-6-3.1-6l-1.3-1l1.3,0.3 C198.2,109.9,205.8,114,207.4,123.1z",
    opacity: 0.05
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    id: "connect_svg__path77",
    className: "connect_svg__st1",
    d: "M191.3,107.7l4.5,8.5v10.4l6.3,1.6l-3.9-10.9C198.2,117.4,193.6,108.7,191.3,107.7z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    id: "connect_svg__path79",
    className: "connect_svg__st1",
    d: "M150.4,197.4L150.4,197.4c-0.1-2.5,0.2-5.1,0.9-7.5c3-10.9-2-46.3-2-46.3s1.4-30.2,19.9-35.3 c17.7-4.9,30.2,15.2,31.2,17c0.1,0.1,0.1,0.1,0.1,0.1l7.4-3.2l0,0c0,0,0,0.1,0,0.1c0.1,1.6,1.3,4.9,3.1,8.7 c2.9,6.2,5.2,12.7,6.9,19.4c1.9,7.3,3,14.8,3.3,22.4c0.7,14.8,3.8,24.6,3.8,24.6H150.4z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    id: "connect_svg__path81",
    className: "connect_svg__st6",
    d: "M217.9,150.4l1,6.7l-18.6-31.8l0,0l7.4-3.2l0.1,0.1l0,0.1c0.1,1.6,1.3,4.9,3.1,8.7 C213.9,137.2,216.2,143.8,217.9,150.4z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    id: "connect_svg__path83",
    className: "connect_svg__st6",
    d: "M170.2,34.1c-9.8-1.1-20.1,1.3-27.7,7.5c-7.6,6.2-12.1,16.5-10.4,26.2c1.4,8.1,6.8,15.8,4.9,23.8 c-1.8,7.6-9.5,12-16.4,15.5l-24.2,12.3c-2.6,1.3-5.4,2.9-6.5,5.6c-1.1,2.8,0.1,6,1.6,8.7c1.6,2.6,3.5,5.1,4.3,8 c0.9,3.8-0.4,7.8-2.4,11.1c-2,3.3-4.7,6.1-7,9.3c-3.2,4.3-5.6,9.4-5.9,14.8s1.6,11,5.7,14.4c3.8,3.1,9,4.1,13.9,4.3 c9.9,0.5,19.7-1.3,29.5-3.2l9.4-1.7c8.6-1.6,18-3.6,23.6-10.4c6.5-7.8,5.7-19.1,4.5-29.2c-1.3-10.1-2.5-21.2,3.4-29.5 c3.9-5.4,10.3-8.8,13.4-14.7c5.6-10.8-2.6-24.1,0.1-35.9c0.7-3.4,2.3-6.5,3.3-9.8c1.8-5.9,2-14.3-1.1-19.9 C183.2,36.1,175.5,34.7,170.2,34.1z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    id: "connect_svg__path85",
    className: "connect_svg__st1",
    d: "M169.7,34.1c-9.8-1.1-20.1,1.3-27.7,7.5c-7.6,6.2-12.1,16.5-10.4,26.2c1.4,8.1,6.8,15.8,4.9,23.8 c-1.8,7.6-9.5,12-16.4,15.5l-24.2,12.3c-2.6,1.3-5.4,2.9-6.5,5.6c-1.1,2.8,0.1,6,1.6,8.7c1.6,2.6,3.5,5.1,4.3,8 c0.9,3.8-0.4,7.8-2.4,11.1c-2,3.3-4.7,6.1-7,9.3c-3.2,4.3-5.6,9.4-5.9,14.8s1.6,11,5.7,14.4c3.8,3.1,9,4.1,13.9,4.3 c9.9,0.5,19.7-1.3,29.5-3.2l9.4-1.7c8.6-1.6,18-3.6,23.6-10.4c6.5-7.8,5.7-19.1,4.5-29.2c-1.3-10.1-2.5-21.2,3.4-29.5 c3.9-5.4,10.3-8.8,13.4-14.7c5.6-10.8-2.6-24.1,0.1-35.9c0.7-3.4,2.3-6.5,3.3-9.8c1.8-5.9,2-14.3-1.1-19.9 C182.8,36.1,175,34.7,169.7,34.1z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    id: "connect_svg__path87",
    className: "connect_svg__st6",
    d: "M169.7,34.1c-9.8-1.1-20.1,1.3-27.7,7.5c-7.6,6.2-12.1,16.5-10.4,26.2c1.4,8.1,6.8,15.8,4.9,23.8 c-1.8,7.6-9.5,12-16.4,15.5l-24.2,12.3c-2.6,1.3-5.4,2.9-6.5,5.6c-1.1,2.8,0.1,6,1.6,8.7c1.6,2.6,3.5,5.1,4.3,8 c0.9,3.8-0.4,7.8-2.4,11.1c-2,3.3-4.7,6.1-7,9.3c-3.2,4.3-5.6,9.4-5.9,14.8s1.6,11,5.7,14.4c3.8,3.1,9,4.1,13.9,4.3 c9.9,0.5,19.7-1.3,29.5-3.2l9.4-1.7c8.6-1.6,18-3.6,23.6-10.4c6.5-7.8,5.7-19.1,4.5-29.2c-1.3-10.1-2.5-21.2,3.4-29.5 c3.9-5.4,10.3-8.8,13.4-14.7c5.6-10.8-2.6-24.1,0.1-35.9c0.7-3.4,2.3-6.5,3.3-9.8c1.8-5.9,2-14.3-1.1-19.9 C182.8,36.1,175,34.7,169.7,34.1z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    id: "connect_svg__path89",
    className: "connect_svg__st1",
    d: "M191.3,107.7l17.4,31.9l12.1-6.2c0,0-21.6-29.2-24.4-28.8C193.6,105.2,191.3,107.7,191.3,107.7z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    id: "connect_svg__path91",
    className: "connect_svg__st5",
    d: "M223.4,130.1l-3.9-11.6c0,0-2.8-28.5-13.7-29.5c-10.9-0.9,2.8,30.4,2.8,30.4s4.9,9,3,15.8 C209.7,141.9,223.4,130.1,223.4,130.1z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    id: "connect_svg__path93",
    className: "connect_svg__st6",
    d: "M167.8,151.8l27.1,32.8c0,0,26,18.6,33.2,4.9c0,0,3-37.3-0.5-46.2S223,129,223,129 s-14.4,5.6-15.3,1.6l0.3,37.7c0,0-16.4-60.2-32.1-52.8c-0.2,0.1-0.4,0.2-0.6,0.3C161.7,122.5,158.2,140.2,167.8,151.8z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    id: "connect_svg__path95",
    className: "connect_svg__st1",
    d: "M168.7,151.1l27.1,32.8c0,0,26,18.6,33.2,4.9c0,0,2.1-37.3-1.4-46.2s-3.7-14.4-3.7-14.4 s-14.4,5.6-15.3,1.6l0.6,46.7c0,0-16.6-69.2-32.4-61.8c-0.2,0.1-0.4,0.2-0.6,0.3C162.7,121.8,159.1,139.5,168.7,151.1z"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    id: "connect_svg__circle97",
    className: "connect_svg__st8",
    cx: 237.5,
    cy: 26.8,
    r: 1.9
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    id: "connect_svg__circle99",
    className: "connect_svg__st8",
    cx: 231.4,
    cy: 52.5,
    r: 0.9
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    id: "connect_svg__circle101",
    className: "connect_svg__st8",
    cx: 196.6,
    cy: 26.8,
    r: 0.9
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    id: "connect_svg__circle103",
    className: "connect_svg__st8",
    cx: 119.5,
    cy: 64.5,
    r: 0.9
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    id: "connect_svg__circle105",
    className: "connect_svg__st8",
    cx: 173.2,
    cy: 131.6,
    r: 0.9
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    id: "connect_svg__circle107",
    className: "connect_svg__st8",
    cx: 110.4,
    cy: 88.9,
    r: 0.9
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    id: "connect_svg__circle109",
    className: "connect_svg__st8",
    cx: 271.6,
    cy: 33.7,
    r: 0.9
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    id: "connect_svg__circle111",
    className: "connect_svg__st8",
    cx: 218.9,
    cy: 71.3,
    r: 0.9
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    id: "connect_svg__circle113",
    className: "connect_svg__st8",
    cx: 298.2,
    cy: 59.2,
    r: 0.9
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    id: "connect_svg__circle115",
    className: "connect_svg__st8",
    cx: 237.6,
    cy: 128.3,
    r: 0.9
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    id: "connect_svg__polygon117",
    className: "connect_svg__st8",
    d: "M271.6 61.3L269.6 61.3 269.6 59.4 269.3 59.4 269.3 61.3 267.4 61.3 267.4 61.6 269.3 61.6 269.3 63.5 269.6 63.5 269.6 61.6 271.6 61.6z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    id: "connect_svg__polygon119",
    className: "connect_svg__st8",
    d: "M175.1 176.4L174.2 176.4 174.2 175.6 174.1 175.6 174.1 176.4 173.2 176.4 173.2 176.6 174.1 176.6 174.1 177.4 174.2 177.4 174.2 176.6 175.1 176.6z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    id: "connect_svg__polygon121",
    className: "connect_svg__st8",
    d: "M213.3 150.2L212.5 150.2 212.5 149.4 212.3 149.4 212.3 150.2 211.5 150.2 211.5 150.4 212.3 150.4 212.3 151.2 212.5 151.2 212.5 150.4 213.3 150.4z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    id: "connect_svg__polygon123",
    className: "connect_svg__st8",
    d: "M270.4 96.9L269.6 96.9 269.6 96 269.4 96 269.4 96.9 268.6 96.9 268.6 97 269.4 97 269.4 97.9 269.6 97.9 269.6 97 270.4 97z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    id: "connect_svg__polygon125",
    className: "connect_svg__st8",
    d: "M231.4 110.3L230.6 110.3 230.6 109.5 230.4 109.5 230.4 110.3 229.6 110.3 229.6 110.5 230.4 110.5 230.4 111.3 230.6 111.3 230.6 110.5 231.4 110.5z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    id: "connect_svg__polygon127",
    className: "connect_svg__st8",
    d: "M121.3 95.9L120.4 95.9 120.4 95.1 120.3 95.1 120.3 95.9 119.4 95.9 119.4 96.1 120.3 96.1 120.3 96.9 120.4 96.9 120.4 96.1 121.3 96.1z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    id: "connect_svg__polygon129",
    className: "connect_svg__st8",
    d: "M214.3 41.4L213.4 41.4 213.4 40.6 213.3 40.6 213.3 41.4 212.4 41.4 212.4 41.6 213.3 41.6 213.3 42.4 213.4 42.4 213.4 41.6 214.3 41.6z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    id: "connect_svg__polygon131",
    className: "connect_svg__st8",
    d: "M139.4 33.3L138.5 33.3 138.5 32.5 138.4 32.5 138.4 33.3 137.5 33.3 137.5 33.5 138.4 33.5 138.4 34.3 138.5 34.3 138.5 33.5 139.4 33.5z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    id: "connect_svg__path133",
    className: "connect_svg__st9",
    d: "M233.4,55.4l-1.3,3.4v14h4.7v2.5h2.7l2.5-2.5h3.9l5.2-5.2V55.4 L233.4,55.4z M249.3,66.7l-3,3h-4.8l-2.5,2.5v-2.5h-4V57.2h14.3L249.3,66.7z M246.3,60.6v5.2h-1.8v-5.2H246.3z M241.5,60.6v5.2h-1.8 v-5.2H241.5z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    id: "connect_svg__path141",
    className: "connect_svg__st9",
    d: "M296.5,39c0-0.9-0.5-1.7-1.3-2.1c-1.4-0.7-7.3-2.2-7.3-2.2 s-5.9-1.4-7.5-1.4c-0.9,0-1.7,0.5-2.1,1.3c-0.7,1.4-1.5,4.5-1.5,4.5s-0.7,3.1-0.7,4.7c0,0.9,0.5,1.6,1.3,2c1.4,0.7,7.3,2.2,7.3,2.2 s5.9,1.4,7.5,1.4c0.9,0,1.6-0.5,2.1-1.2c0.7-1.4,1.5-4.5,1.5-4.5S296.6,40.6,296.5,39L296.5,39z M283.8,43.7l1.3-5.6l4.2,4 L283.8,43.7L283.8,43.7z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "connect_svg__g1031",
    transform: "matrix(1.18097 0 0 1.18097 377.154 -114.47)",
    className: "connect_svg__st10"
  }, /*#__PURE__*/React.createElement("g", {
    id: "connect_svg__g1035",
    transform: "matrix(.3659 0 0 .3659 133.163 139.504)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "connect_svg__path1017",
    d: "M-747.7-65.3c-1.3,0-2.4,1.2-2.4,2.6s1.1,2.6,2.4,2.6 c1.3,0,2.4-1.2,2.4-2.6C-745.3-64.1-746.4-65.3-747.7-65.3z M-739.2-65.3c-1.3,0-2.4,1.2-2.4,2.6s1.1,2.6,2.4,2.6 c1.3,0,2.4-1.2,2.4-2.6S-737.9-65.3-739.2-65.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "connect_svg__path1019",
    d: "M-728-84.7H-759c-2.6,0-4.8,2.1-4.8,4.8v31.4c0,2.6,2.1,4.8,4.8,4.8h26.3 l-1.2-4.3l3,2.8l2.8,2.6l5,4.4V-80C-723.2-82.6-725.3-84.7-728-84.7z M-736.9-54.4c0,0-0.8-1-1.5-1.9c3-0.9,4.2-2.8,4.2-2.8 c-1,0.6-1.9,1.1-2.7,1.4c-1.2,0.5-2.3,0.8-3.4,1c-2.2,0.4-4.3,0.3-6,0c-1.3-0.3-2.5-0.6-3.4-1c-0.5-0.2-1.1-0.5-1.7-0.8 c-0.1,0-0.1-0.1-0.2-0.1c0,0-0.1,0-0.1-0.1c-0.4-0.2-0.6-0.4-0.6-0.4s1.1,1.9,4.1,2.7c-0.7,0.9-1.6,1.9-1.6,1.9 c-5.1-0.2-7.1-3.5-7.1-3.5c0-7.5,3.3-13.5,3.3-13.5c3.3-2.5,6.5-2.4,6.5-2.4l0.2,0.3c-4.2,1.2-6.1,3-6.1,3s0.5-0.3,1.4-0.7 c2.5-1.1,4.5-1.4,5.3-1.5c0.1,0,0.3,0,0.4,0c1.4-0.2,3-0.2,4.7,0c2.2,0.3,4.6,0.9,7,2.2c0,0-1.8-1.7-5.8-2.9l0.3-0.4 c0,0,3.2-0.1,6.5,2.4c0,0,3.3,6.1,3.3,13.5C-729.8-58-731.8-54.6-736.9-54.4z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "connect_svg__g1059",
    transform: "translate(-12.5 -154.402) scale(1.16875)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "connect_svg__g1057",
    transform: "matrix(2.0591 0 0 2.0591 -58.29 -655.571)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "connect_svg__path1051",
    className: "connect_svg__st11",
    d: "M152.4,411c2.3,0,4.2,1.9,4.2,4.2c0,2.3-1.9,4.2-4.2,4.2 c-1.9,0-3.5-1.3-4-3l1.6,0.6c0.1,0.6,0.6,1,1.2,1c0.6,0,1.2-0.5,1.2-1.1l1.6-1.2c0.9,0,1.7-0.7,1.7-1.6c0-0.9-0.7-1.7-1.7-1.7 c-0.9,0-1.6,0.7-1.7,1.6l-1,1.5c0,0-0.1,0-0.1,0c-0.2,0-0.4,0.1-0.6,0.2l-2.3-0.9C148.5,412.6,150.2,411,152.4,411"
  }), /*#__PURE__*/React.createElement("path", {
    id: "connect_svg__path1053",
    className: "connect_svg__st11",
    d: "M154,413.1c-0.5,0-0.9,0.4-0.9,0.9c0,0.5,0.4,0.9,0.9,0.9 c0.5,0,0.9-0.4,0.9-0.9C154.9,413.5,154.5,413.1,154,413.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "connect_svg__path1055",
    className: "connect_svg__st11",
    d: "M151.2,415.8c0.5,0,0.9,0.4,0.9,0.9c0,0.5-0.4,0.9-0.9,0.9 c-0.3,0-0.7-0.2-0.8-0.5c0.1,0.1,0.3,0.1,0.4,0.2c0.4,0.1,0.8,0,0.9-0.4c0.1-0.4,0-0.8-0.4-0.9l-0.4-0.2 C151.1,415.8,151.1,415.8,151.2,415.8"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "connect_svg__st10"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M241.9 96.5l0 .7c.2-.3.4-.5.7-.7.3-.1.5-.2.9-.2.6 0 1.1.3 1.5.9.2-.3.4-.5.7-.7.2-.1.5-.2.8-.2.4 0 .7.1 1 .3s.4.4.5.7.1.7.1 1.4v5.5h-2.3v-5.1c0-.7 0-1.1-.1-1.2s-.1-.2-.3-.2c-.2 0-.3.1-.3.2s-.1.6-.1 1.2v5.1h-2.3v-4.9c0-.8 0-1.2-.1-1.4s-.1-.2-.3-.2c-.1 0-.2 0-.3.1s-.1.2-.1.3 0 .4 0 .7v5.4h-2.3v-7.8H241.9zM250.9 99.5h-2.2V99c0-.6.1-1.1.2-1.4s.4-.6.8-.9 1-.4 1.6-.4c.8 0 1.4.1 1.8.4s.7.6.7 1 .1 1.3.1 2.5v3.9h-2.3v-.7c-.1.3-.3.5-.6.6-.2.1-.5.2-.8.2-.4 0-.8-.1-1.1-.3s-.5-.7-.5-1.5v-.6c0-.6.1-1 .3-1.2s.6-.5 1.4-.7c.8-.3 1.2-.5 1.2-.6s.1-.3.1-.6c0-.4 0-.7-.1-.8s-.2-.2-.3-.2c-.2 0-.3.1-.3.2s-.1.4-.1.8V99.5zM251.7 100.6c-.4.3-.6.5-.7.7s-.1.5-.1.8c0 .4 0 .7.1.8s.2.2.3.2c.1 0 .2 0 .3-.1s.1-.3.1-.7V100.6zM257.3 94.8v9.5h-2.4v-9.5H257.3z"
  }))));
}

export default SvgConnect;